import { Component, OnInit, Input } from "@angular/core";
import { ConsensusTemplateTableData } from "../qc-dashboard.model";

@Component({
  selector: "app-consensus-bar",
  templateUrl: "./consensus-bar.component.html",
  styleUrls: ["./consensus-bar.component.scss"],
})
export class ConsensusBarComponent implements OnInit {
  @Input() data: ConsensusTemplateTableData;
  total = 0;
  forcastUsedWidth = 0;
  forcastExcludedWidth = 0;
  forcastInferredWidth = 0;
  forcastBlankWidth = 0;

  forcastUsedTitle = "";
  forcastBlankTitle = "";
  forcastExcludedTitle = "";
  forcastInferredTitle = "";

  ngOnInit() {
    this.total =
      this.data.forecast_excluded +
      this.data.forecast_used +
      this.data.n_forecast_blank +
      this.data.n_forecast_inferred;
    // i.e. total is non-zero
    if (this.total) {
      this.forcastUsedWidth = (this.data.forecast_used / this.total) * 120;
      this.forcastUsedTitle = `${Math.round(
        (this.data.forecast_used / this.total) * 100,
      )}% Used`;
      this.forcastBlankWidth = (this.data.n_forecast_blank / this.total) * 120;
      this.forcastBlankTitle = `${Math.round(
        (this.data.n_forecast_blank / this.total) * 100,
      )}% Blank`;
      this.forcastExcludedWidth =
        (this.data.forecast_excluded / this.total) * 120;
      this.forcastExcludedTitle = `${Math.round(
        (this.data.forecast_excluded / this.total) * 100,
      )}% Excluded`;
      this.forcastInferredWidth =
        (this.data.n_forecast_inferred / this.total) * 120;
      this.forcastInferredTitle = `${Math.round(
        (this.data.n_forecast_inferred / this.total) * 100,
      )}% Inferred`;
    }
  }
}
